import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import Button from '@/components/Button';
import useResponsive from '@/hooks/useResponsive';

import DropzoneMultiImage from './DropzoneMultiImage';

export interface AddProductStepProps {
  step: number;
  setCurrentStep: (step: number) => void;
  setUrlTemplate?: (url: string | null) => void;
  importProducts?: (file: File) => void;
  getTemplate?: (images: File[]) => void;
  urlTemplate?: string | null;
  isPendingTemplate?: boolean;
  isPendingImport?: boolean;
  close?: () => void;
  register?: any;
  errors?: any;
  setImages?: (images: File[] | ((prev: File[]) => File[])) => void;
  images?: File[];
}

const AddProductStepOne = ({
  step,
  setCurrentStep,
  getTemplate,
  images,
  setImages,
}: AddProductStepProps) => {
  const theme = useTheme();
  const isSmallDrawer = useResponsive('between', 'lg', 'xl');
  const isPhone = useResponsive('down', 'sm');

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          margin: '1rem 0',
          [theme.breakpoints.between('lg', 'xl')]: {
            flexDirection: 'column',
            gap: '1rem',
          },
          [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            gap: '1rem',
          },
        }}
      >
        <Typography variant="subtitle1" sx={{ minWidth: '4.1rem' }}>
          Paso <span style={{ color: theme.palette.primary.main }}>1</span>
        </Typography>
        <Divider
          orientation={isSmallDrawer || isPhone ? 'horizontal' : 'vertical'}
          flexItem
          sx={{
            margin: isSmallDrawer || isPhone ? '0' : `0 ${theme.spacing(2)}`,
          }}
        />
        <Box>
          <Typography
            variant="body1"
            sx={{
              color: theme.palette.grey[600],
              '&& span': { color: theme.palette.primary.main },
            }}
          >
            <span>Agrega las fotos y copia las URLs,</span> luego pégalas en tu plantilla de Excel{' '}
            <br />
            <br /> Te compartimos algunos consejos para <span>conseguir una buena foto:</span>
          </Typography>
          <Grid
            container
            spacing={1}
            sx={{
              color: theme.palette.grey[600],
              margin: '1rem 0',
              fontSize: '0.9rem',
              gap: '1rem',
              justifyContent: 'space-between',
            }}
          >
            <Grid container spacing={1} size={{ xxs: 12, xs: 5.8, lg: 12, xl: 5.8 }}>
              <ul style={{ listStylePosition: 'outside', paddingLeft: '20px' }}>
                <li>
                  <strong>Asegúrate de que el archivo tenga el nombre del producto</strong>
                </li>
                <li>Intenta tomar tu foto con fondo blanco</li>
                <li>Muestra un solo producto por foto</li>
              </ul>
            </Grid>
            <Grid container spacing={1} size={{ xxs: 12, xs: 5.8, lg: 12, xl: 5.8 }}>
              <ul style={{ listStylePosition: 'outside', paddingLeft: '20px' }}>
                <li>No agregues elementos extra a tus fotos</li>
                <li>Asegúrate de que no sean borrosas</li>
                <li> Evita descargar fotos de Internet</li>
              </ul>
            </Grid>
          </Grid>
          <Typography
            variant="body1"
            sx={{
              color: theme.palette.grey[600],
              fontWeight: 'bold',
              '&& span': { color: theme.palette.primary.main },
            }}
          >
            <span>Genera las URLs</span> para cada uno de tus productos.
          </Typography>
          <Divider flexItem sx={{ margin: `${theme.spacing(2)} 0`, width: '100%' }} />
          <Typography>
            Agrega las fotos y obtén las URLs para completar tu plantilla de Excel.
          </Typography>

          <DropzoneMultiImage images={images!} setImages={setImages!} />
        </Box>
      </Box>
      <Grid container justifyContent="flex-end">
        <Button
          disabled={images?.length === 0}
          onClick={() => {
            getTemplate?.(images!);
            setCurrentStep(step + 1);
          }}
        >
          Siguiente
        </Button>
      </Grid>
    </>
  );
};

export default AddProductStepOne;
